@if (!isExpiring) {
  <p-button type="button" size="small" severity="warn" (onClick)="startExpire()" label="Expire"></p-button>
}
@if (isExpiring) {
  <div>
    @if (mailer === 'gomail') {
      <div class="form-group row">
        <label for="sendmail" class="form-check-label"><b>Send list removal mail </b></label>
        <input id="sendmail" type="checkbox" class="form-check-input" [ngModelOptions]="{ standalone: true }" [(ngModel)]="sendmail" />
      </div>
    }
    <div class="form-group row">
      <p-button severity="secondary" size="small" type="button" styleClass="  btn-xs" (onClick)="cancel()" label="Abort expiration"></p-button>
      <p-button severity="danger" size="small" type="button" styleClass="  btn-xs" (onClick)="confirm()" label="Confirm"></p-button>
    </div>
  </div>
}
